// extracted by extract-css-chunks-webpack-plugin
module.exports = {"titleContainer":"post-list-view__titleContainer__WzwaU","contentContainer":"post-list-view__contentContainer__28cT2","sidenav":"post-list-view__sidenav__33CET"};